// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const PROD_NATUREZA = {
  ProdutoFisico: 'PROD_NATUREZA1',
  Servico: 'PROD_NATUREZA2',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    PROD_NATUREZA1: 1,
    PROD_NATUREZA2: 2
  }
}
